<template>
  <div class="app-content content " :class="[{ 'show-overlay': app_store.shallShowOverlay }, $route.meta.contentClass]" >
    <div class="content-overlay " />
    <div class="header-navbar-shadow " />

    <div class="content-wrapper container-fluid px-0 mx-0" :class="contentWidth === 'boxed' ? 'container p-0' : null" >
      <slot name="breadcrumb">
        <app-breadcrumb />
      </slot>

      <div class="content-body">
        <router-view v-slot="{ Component }">
          <transition :name="routerTransition" mode="out-in">
            <component :is="Component" />
          </transition>
        </router-view>
      </div>
    </div>
  </div>
</template>

<script setup>
import AppBreadcrumb from '@layouts/components/AppBreadcrumb.vue';
import useAppConfig from '@/app-config/useAppConfig';
import useAppStore from '@/store/app';

const app_store = useAppStore();
const { routerTransition, contentWidth } = useAppConfig();
</script>
